module.exports = __webpack_public_path__ + "static/media/transparent-email.77bd4f53.svg";